/** A schema to describe the clinicalTrialStages slice. */
export const FacetSearchClinicalTrialStagesSlice = {
  display: [],
  selected: [],
}
